export const GROUP_VISUAL_STATE = {
  NORMAL: 0,
  MINIMIZED: 1,
};

export const CALENDAR_DATE_RANGE_TYPE = {
  AVAILABILITY_OVERRIDE: 0,
  DEPLOYMENT: 1,
};

export const ACTIONS = {
  /**
   * Company Group Relation
   */
  GET_COMPANY_GROUP_RELATIONS: "GET_COMPANY_GROUP_RELATIONS",
  CREATE_COMPANY_GROUP_RELATION: "CREATE_COMPANY_GROUP_RELATION",

  /**
   * Search
   */
  SEARCH_VIEW: "SEARCH_VIEW",

  /**
   * Crew
   */
  CREATE_CREW: "CREATE_CREW",
  DELETE_CREW: "DELETE_CREW",
  GET_CREWS: "GET_CREWS",
  UPDATE_CREW: "UPDATE_CREW",

  /**
   * Qualification
   */
  GET_QUALIFICATION: "GET_QUALIFICATION",
  GET_QUALIFICATIONS: "GET_QUALIFICATIONS",
  UPDATE_QUALIFICATION: "UPDATE_QUALIFICATION",
  CREATE_QUALIFICATION: "CREATE_QUALIFICATION",
  DELETE_QUALIFICATION: "DELETE_QUALIFICATION",

  /**
   * Card
   */
  GET_CARD: "GET_CARD",
  GET_CARDS: "GET_CARDS",
  GET_CARD_MOVES: "GET_CARD_MOVES",
  GET_CARD_ALL_DEPLOYMENTS: "GET_CARD_ALL_DEPLOYMENTS",
  GET_CARD_OPEN_DEPLOYMENTS: "GET_CARD_OPEN_DEPLOYMENTS",
  UPDATE_CARD_OPEN_DEPLOYMENT: "UPDATE_CARD_OPEN_DEPLOYMENT",
  UNLOAD_CARD_DEPLOYMENTS: "UNLOAD_CARD_DEPLOYMENTS",
  DELETE_DEPLOYMENT_DETAIL: "DELETE_DEPLOYMENT_DETAIL",
  EDIT_CARD: "EDIT_CARD",
  DELETE_CARD: "DELETE_CARD",
  UPDATE_CARD: "UPDATE_CARD",
  CLEAR_CARDS: "CLEAR_CARDS",
  GET_GROUP_CARDS: "GET_GROUP_CARDS",

  /**
   * View
   */
  GET_VIEWS: "GET_VIEWS",
  GET_VIEW: "GET_VIEW",
  GET_USER_DEFAULT_VIEW_ID: "GET_USER_DEFAULT_VIEW_ID",
  SET_USER_DEFAULT_VIEW_ID: "SET_USER_DEFAULT_VIEW",
  CREATE_VIEW: "CREATE_VIEW",
  UPDATE_VIEW: "UPDATE_VIEW",
  DELETE_VIEW: "DELETE_VIEW",
  GET_VIEW_COMPETENCY_STATUSES: "GET_VIEW_COMPETENCY_STATUSES",

  /**
   * Group
   */
  GET_GROUPS: "GET_GROUPS",
  GET_GROUP: "GET_GROUP",
  GET_GROUP_CARDS_SUMMARIZED_COMPETENCY_STATUS:
    "GET_GROUP_CARDS_SUMMARIZED_COMPETENCY_STATUS",
  GET_GROUP_OPEN_DEPLOYMENTS: "GET_GROUP_OPEN_DEPLOYMENTS",
  GET_GROUP_STATS: "GET_GROUP_STATS",
  EDIT_GROUP: "EDIT_GROUP",
  CREATE_GROUP: "CREATE_GROUP",
  DELETE_GROUP: "DELETE_GROUP",
  UPDATE_GROUP_FLAG_TYPE: "UPDATE_GROUP_FLAG_TYPE",
  GET_REPLACEABLE_EMPLOYEES: "GET_REPLACEABLE_EMPLOYEES",
  ADD_EMPLOYEES_TO_GROUP: "ADD_EMPLOYEES_TO_GROUP",
  GROUP_EXISTS: "GROUP_EXISTS",
  GET_VIEW_GROUP_PROJECTS: "GET_VIEW_GROUP_PROJECTS",
  GET_GROUP_PROJECTS: "GET_GROUP_PROJECTS",
  GROUP_UNDELETE: "GROUP_UNDELETE",
  RESET_GROUP_FORM_FACILITY: "RESET_GROUP_FORM_FACILITY",

  /**
   * Company
   */
  CREATE_COMPANY: "CREATE_COMPANY",
  DELETE_COMPANY: "DELETE_COMPANY",
  GET_COMPANIES: "GET_COMPANIES",
  GET_COMPANY: "GET_COMPANY",
  UPDATE_COMPANY: "UPDATE_COMPANY",
  CREATE_COMPANY_COURSE: "CREATE_COMPANY_COURSE",
  DELETE_COMPANY_COURSE: "DELETE_COMPANY_COURSE",
  CLEAR_COMPANY_COURSES: "CLEAR_COMPANY_COURSES",

  /**
   * Field
   */
  GET_FIELDS: "GET_FIELDS",
  CREATE_FIELD: "CREATE_FIELD",
  UPDATE_FIELD: "UPDATE_FIELD",
  DELETE_FIELD: "DELETE_FIELD",

  /**
   * Facility
   */
  UPDATE_FIXED_FACILITY: "UPDATE_FIXED_FACILITY",
  CREATE_FIXED_FACILITY: "CREATE_FIXED_FACILITY",
  DELETE_FIXED_FACILITY: "DELETE_FIXED_FACILITY",
  UPDATE_MOBILE_FACILITY: "UPDATE_MOBILE_FACILITY",
  CREATE_MOBILE_FACILITY: "CREATE_MOBILE_FACILITY",
  DELETE_MOBILE_FACILITY: "DELETE_MOBILE_FACILITY",
  /**
   * Marker
   */
  GET_MARKERS: "GET_MARKERS",
  DELETE_MARKER: "DELETE_MARKER",
  UPDATE_MARKER: "UPDATE_MARKER",
  CREATE_MARKER: "CREATE_MARKER",

  /**
   * View Group
   */
  UPDATE_VIEW_GROUP: "UPDATE_VIEW_GROUP",
  DELETE_VIEW_GROUP: "DELETE_VIEW_GROUP",
  CREATE_VIEW_GROUPS: "CREATE_VIEW_GROUPS",
  GET_VIEW_GROUP: "GET_VIEW_GROUP",

  /**
   * WebSocket
   */
  WEBSOCKET_OPEN: "WEBSOCKET_OPEN",
  WEBSOCKET_CLOSE: "WEBSOCKET_CLOSE",
  WEBSOCKET_ERROR: "WEBSOCKET_ERROR",

  /**
   * Employee Group
   */
  GET_EMPLOYEE_GROUPS: "GET_EMPLOYEE_GROUPS",
  CREATE_EMPLOYEE_GROUP: "CREATE_EMPLOYEE_GROUP",
  UPDATE_EMPLOYEE_GROUP: "UPDATE_EMPLOYEE_GROUP",
  DELETE_EMPLOYEE_GROUP: "DELETE_EMPLOYEE_GROUP",

  /**
   * Employee Course
   */
  GET_EMPLOYEE_COURSES: "GET_EMPLOYEE_COURSES",
  CLEAR_EMPLOYEE_COURSES: "CLEAR_EMPLOYEE_COURSES",

  /**
   * Work Days
   */
  GET_WORK_DAYS_BY_EMPLOYEE: "GET_WORK_DAYS_BY_EMPLOYEE",

  /**
   * Sub Contractors
   */
  GET_SUB_CONTRACTORS: "GET_SUB_CONTRACTORS",
  GET_SUB_CONTRACTOR: "GET_SUB_CONTRACTOR",
  DELETE_SUB_CONTRACTOR: "DELETE_SUB_CONTRACTOR",
  CREATE_SUB_CONTRACTOR: "CREATE_SUB_CONTRACTOR",
  UPDATE_SUB_CONTRACTOR: "UPDATE_SUB_CONTRACTOR",

  ADD_VIEW_COLUMN: "ADD_VIEW_COLUMN",
  DELETE_VIEW_COLUMN: "DELETE_VIEW_COLUMN",
  UPDATE_VIEW_GROUPS_ORDER: "UPDATE_VIEW_GROUPS_ORDER",
  SORT_VIEW_GROUP: "SORT_VIEW_GROUP",
  CHANGE_VIEW_GROUP_COLUMN: "CHANGE_VIEW_GROUP_COLUMN",
  CLEAR_SEARCH: "CLEAR_SEARCH",
  CREATE_CARD: "CREATE_CARD",
  GROUP_LOADED: "GROUP_LOADED",
  GET_COUNTRIES: "GET_COUNTRIES",
  CREATE_CARD_MOVE: "CREATE_CARD_MOVE",
  DISPLAY_CARD_MOVES: "DISPLAY_CARD_MOVES",
  CONFIRM_DELETE_CARD: "CONFIRM_DELETE_CARD",
  GET_MOBILE_FACILITIES: "GET_MOBILE_FACILITIES",
  CREATE_CARD_MOVE_ERROR: "CREATE_CARD_MOVE_ERROR",
  PLANNER_CONTAINER_LOADED: "PLANNER_CONTAINER_LOADED",
  GET_STATIONARY_FACILITIES: "GET_STATIONARY_FACILITIES",
  CREATE_GROUP_AND_VIEW_GROUP: "CREATE_GROUP_AND_VIEW_GROUP",
  GET_STATIONARY_AND_MOBILE_FACILITIES: "GET_STATIONARY_AND_MOBILE_FACILITIES",
  SETTINGS_COMPANY_ON_LOAD: "SETTINGS_COMPANY_ON_LOAD",
  INITIALIZE_EDIT_COMPANY: "INITIALIZE_EDIT_COMPANY",
  CLEAR_VIEW: "CLEAR_VIEW",
  GET_CARD_MISSING_COMPETENCY_STATUS_ITEMS_FOR_GROUP:
    "GET_CARD_MISSING_COMPETENCY_STATUS_ITEMS_FOR_GROUP",
};

export const CARD_CONTAINER_TYPE = {
  ONSHORE: 0,
  ALLOCATED_OFFSHORE: 1,
  DEPLOYED_OFFSHORE: 2,
};

export const GROUP_TYPES = {
  PLANNING_GROUP: 0,
  LOCATION_GROUP: 1,
};

export const ITEM_TYPES = {
  CARD: "card",
  PLANNING_GROUP: GROUP_TYPES.PLANNING_GROUP,
  LOCATION_GROUP: GROUP_TYPES.LOCATION_GROUP,
  CALENDAR_DAY: "calendarDay",
};

export const GROUP_FLAG_TYPES = {
  NONE: 0,
  GREEN: 1,
  YELLOW: 2,
  RED: 3,
};

export const CARD_TYPES = {
  EMPLOYEE: 0,
  DUMMY: 1,
};

export const REQUIREMENT_TYPES = {
  COURSE: 0,
  SKILL: 1,
};

export const CRITICALITY = {
  CRITICAL: 0,
  NOT_CRITICAL: 1,
};

export const EMPLOYEE_TYPES = {
  EMPLOYEE: 0,
  SUB_CONTRACTOR: 1,
};

export const CREATE_CARD_TYPE = {
  SUB_CONTRACTOR: 0,
  DUMMY: 1,
};

export const SHIFT_TYPES = {
  DAY: 0,
  NIGHT: 1,
  MID: 2,
};

export const SEARCH_OBJECT_TYPES = {
  ALL: 0,
  GROUP: 1,
  CARD: 2,
};

export const BOOKING_SYSTEM_TYPES = {
  DA_WINCHI: 0,
  TICKET: 1,
  VANTAGE: 2,
};

export const CREATE_CARD_MODAL_ID = "CREATE_CARD";

export const CARD_FORM = {
  ID: "createCard",
  NAME: "name",
  TYPE: "type",
  SLOT_NO: "slotNo",
  CARD_CONTAINER_ID: "cardContainerId",
  BACK_COLOR: "backColor",
};

export const DEPLOYMENT_DETAILS_FORM = {
  ID: "deploymentDetails",
  START_DATE: "startDate",
  END_DATE: "endDate",
  GROUP_NAME: "groupName",
  SHIFT: "shiftType",
  QUALIFICATION_NAME: "qualificationName",
};

export const GROUP_FORM = {
  ID: "editGroup",
  NAME: "name",
  TYPE: "type",
  GROUP_ID: "id",
  INSTALLATION_PHONE: "installationPhone",
  OFFICE_PHONE: "officePhone",
  WINCH_PHONE: "winchPhone",
  BOOKING_CONTACT: "bookingContact",
  BOOKING_PHONE: "bookingPhone",
  BOOKING_EMAIL: "bookingEmail",
  AIRPORT: "airport",
  SHORT_NAME: "shortName",
  CUSTOMER_SERVICE_LEAD: "customerServiceLeadId",
  OPERATION_SUPERVISOR: "operationSupervisorId",
  BOOKING_SYSTEM_TYPE: "bookingSystemType",
  COMPANY_ID: "companyId",
  FIELD: "field",
  FACILITY: "facility",
  FACILITY_ID: "facilityId",
  FACILITY_TYPE: "facilityType",
  SPECIFICATION: "specificationId",
};

export const EDIT_CARD_MODAL_ID = "EDIT_CARD";

export const VIEW_TYPES = {
  PRIVATE: 0,
  PUBLIC: 1,
};

export const USER_TYPES = {
  VIEWER: 0,
  PLANNER: 1,
  ADMIN: 2,
};

export const CREATE_VIEW_FORM = {
  ID: "createView",
  NAME: "name",
  TYPE: "type",
};

export const FACILITY_STATUS = {
  UNKNOWN: 0,
  ABANDONED: 1,
  DECOMMISSIONED: 2,
  FABRICATION: 3,
  FUTURE: 4,
  IN_SERVICE: 5,
  INSTALLATION: 6,
  LAID_UP: 7,
  REMOVED: 8,
};

export const FIELD_STATUS = {
  UNKNOWN: 0,
  PRODUCING: 1,
  PRODUCTION_UNLIKELY: 2,
  PRODUCTION_LIKELY: 3,
  PRODUCTION_APPROVED: 4,
  PRODUCTION_IN_CLARIFICATION_PHASE: 5,
  PRODUCTION_NOT_EVALUATED: 6,
  PRODUCTION_DECIDED: 7,
  INCLUDED_IN_OTHER_DISCOVERY: 8,
  SHUT_DOWN: 9,
};

export const FACILITY_TYPE = {
  FIXED: 0,
  MOBILE: 1,
};

export const SORT_DIRECTION = {
  ASC: "asc",
  DESC: "desc",
};

export const CREATE_VIEW_GROUPS_MODAL_ID = "ADD_TO_VIEW_MODAL";

export const DEPLOY_OFFSHORE_MODAL_ID = "DEPLOY_OFFSHORE";

export const SHUTTLE_OFFSHORE_MODAL_ID = "SHUTTLE_OFFSHORE";

export const RETURN_ONSHORE_MODAL_ID = "RETURN_ONSHORE";

export const MISSING_COMPETENCE_MODAL_ID = "MISSING_COMPETENCE";

export const CREATE_CARD_MOVE_FORM = {
  ID: "createCardMove",
  DEPARTURE: "departure",
  ARRIVAL: "arrival",
  FROM: "from",
  HOUR: "hour",
  MINUTE: "minute",
  DATE: "date",
  SHIFT: "shiftType",
  QUALIFICATION_ID: "qualificationId",
  DEPLOYMENT_DETAILS: "deploymentDetails",
  DEPARTURE_DATE: "deploymentDetails.departure.date",
  DEPARTURE_HOUR: "deploymentDetails.departure.hour",
  DEPARTURE_MINUTE: "deploymentDetails.departure.minute",
  ARRIVAL_DATE: "deploymentDetails.arrival.date",
  ARRIVAL_HOUR: "deploymentDetails.arrival.hour",
  ARRIVAL_MINUTE: "deploymentDetails.arrival.minute",
  FROM_DATE: "deploymentDetails.from.date",
  FROM_HOUR: "deploymentDetails.from.hour",
  FROM_MINUTE: "deploymentDetails.from.minute",
  SHIFT_TYPE: "deploymentDetails.shiftType",
  QUALIFICATION: "deploymentDetails.qualificationId",
  CREW: "deploymentDetails.crewId",
  CREW_ID: "crewId",
  REPLACE_EMPLOYEE: "deploymentDetails.replaceEmployeeId",
  REPLACE_EMPLOYEE_ID: "replaceEmployeeId",
  EMPLOYEE: "employee",
  CARD: "cardId",
  COMMENT: "comment",
  DEPLOYMENT_COMMENT: "deploymentDetails.comment",
  TARGET_GROUP_ID: "targetGroupId",
  SOURCE_GROUP_ID: "sourceGroupId",
  TARGET_CARD_CONTAINER_ID: "targetCardContainerId",
  EMPLOYEE_PROJECTS: "employee.projects",
  GROUP_PROJECTS: "projects",
};

export const FIELD_FORM = {
  ID: "editField",
  NAME: "name",
  STATUS: "status",
  OPERATOR: "operator",
  COUNTRY: "countryId",
  SOURCE_URI: "sourceUri",
};

export const CREATE_FIXED_FACILITY_FORM = {
  ID: "createFixedFacility",
  NAME: "name",
  FIELD: "fieldId",
  STATUS: "status",
  OPERATOR: "operator",
};

export const EDIT_FIXED_FACILITY_FORM = {
  ID: "editFixedFacility",
  NAME: "name",
  FIELD: "fieldId",
  STATUS: "status",
  OPERATOR: "operator",
  SOURCE_URI: "sourceUri",
};

export const MOBILE_FACILITY_FORM = {
  ID: "mobileFacility",
  NAME: "name",
  NATION: "nation",
  OPERATOR: "operator",
  SOURCE_URI: "sourceUri",
};

export const COMPANY_FORM = {
  ID: "company",
  NAME: "name",
  COUNTRY: "countryId",
  IS_CUSTOMER: "isCustomer",
  IS_SUPPLIER: "isSupplier",
  CONTACT_NAME: "contactName",
  CONTACT_PHONE: "contactPhone",
  CONTACT_MOBILE: "contactMobile",
  CONTACT_EMAIL: "contactEmail",
  NOTES: "notes",
  SPECIFICATION: "specificationId",
};

export const CREW_FORM = {
  ID: "crew",
  NAME: "name",
};
export const QUALIFICATION_FORM = {
  ID: "qualification",
  NAME: "name",
  BACKCOLOR: "backColor",
};

export const VIEW_SIDE_PANEL_ID = "VIEW_SIDE_PANEL_ID";

export const SEARCH_SIDE_PANEL_ID = "SEARCH_SIDE_PANEL_ID";

export const MARKER_FORM = {
  ID: "editMarker",
  NAME: "name",
  ICON: "icon",
  FILE: "files",
};

export const WORK_SCHEDULE_OVERRIDE_REASONS = {
  AVAILABLE: 0,
  SICK: 1 << 0,
  TRAINING: 1 << 1,
  MILITARY_SERVICE: 1 << 2,
  LEAVE_OF_ABSCENCE: 1 << 3,
  PROJECT_BASE: 1 << 4,
  VACATION: 1 << 5,
  LABOR_UNION: 1 << 6,
  QUARANTINE: 1 << 7,
  LAYOFF: 1 << 8,
};

export const EMPLOYEE_GROUP_FORM = {
  ID: "employeeGroup",
  NAME: "name",
};

export const SUB_CONTRACTOR_FORM = {
  ID: "subContractor",
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
  COMPANY: "companyId",
  TYPE: "type",
  CARD_TYPE: "cardType",
  TRAVEL_AIRPORT: "travel.airport",
  TRAVEL_DA_WINCI: "travel.daWinci",
  TRAVEL_TICKET: "travel.ticket",
  TRAVEL_VANTAGE: "travel.vantage",
  EMPLOYEE_GROUP: "employeeGroupId",
  MARKERS: "markers",
  NOTES: "notes",
  EMAIL_WORK: "emailWork",
  HIRED_FROM: "hiredFrom",
  HIRED_TO: "hiredTo",
  PHONE: "phone",
  CELL_PHONE: "cellPhone",
  SHIFT: "shift",
  QUALIFICATION: "qualificationId",
};

export const SUB_CONTRACTOR_COMPANY_FORM = {
  ID: "subContractorCompany",
  COMPANY_ID: "id",
  CONTACT_EMAIL: "contactEmail",
  DUTY_PHONE: "contactPhone",
  NOTES: "notes",
};

export const COURSE_TYPES = {
  E_LEARNING: 0,
  INSTRUCTED: 1,
  ON_THE_JOB_TRAINING: 2,
  ASSESSMENT: 3,
};

export const COMPETENCY_STATUS = {
  NONE: 0,
  MISSING_REQUIREMENTS: 1,
  EXPIRED: 2,
  NOT_APPROVED: 3,
  EXPIRES_SOON: 4,
  REQUIRES_APPROVAL: 5,
  UP_TO_DATE: 6,
};

export const EDIT_LOCATION_GROUP_MODAL_ID = "editLocationGroup";
export const EDIT_COMPANY_MODAL_ID = "editCompany";

export const CREATE_VIEW_GROUPS_FORM = {
  ID: "addToView",
  ACTIVE_TAB: "activeTab",
  SELECTED_ITEMS: "selectedItems",
  GROUP_ID: "groupId",
  INCLUDE_HIDDEN_CARDS: "includeHideInPlanning",
  VIEW_ID: "viewId",
};

export const CREATE_VIEW_GROUPS_TABS = {
  PLANNING_GROUP: 0,
  LOCATION_GROUP: 1,
};

export const WORK_SCHEDULE_STATUS = {
  OFF: 1,
  ON: 2,
  OFF_FLEX: 17,
};

export const GROUP_ROW_COUNT = {
  EMPTY_ROWS: 1,
  MINIMUM: 1,
};

export const DASHBOARD_EMPLOYEES_MODAL = "DASHBOARD_EMPLOYEES_MODAL";
